/**
 * defines the common methods for the barcode
 */
var BarcodeBase = /** @class */ (function () {
    function BarcodeBase() {
    }
    return BarcodeBase;
}());
export { BarcodeBase };
